import { render, staticRenderFns } from "./VaNoDataTag.vue?vue&type=template&id=d7620a7c&scoped=true&"
import script from "./VaNoDataTag.vue?vue&type=script&lang=ts&"
export * from "./VaNoDataTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7620a7c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7620a7c')) {
      api.createRecord('d7620a7c', component.options)
    } else {
      api.reload('d7620a7c', component.options)
    }
    module.hot.accept("./VaNoDataTag.vue?vue&type=template&id=d7620a7c&scoped=true&", function () {
      api.rerender('d7620a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaNoDataTag.vue"
export default component.exports